// Only allow same-origin, absolute internal paths to defeat open-redirect via crafted ?returnUrl=
export const isSafeInternalPath = (value: string): boolean =>
  value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/\\');

export const handleReturnUrl = (
  returnTo: string,
  loginPath: string,
  adminPath: string,
  authPath?: string,
  pathsToIgnore: readonly string[] = [],
): string => {
  const sanitizedReturnTo = returnTo.replace(/\/+$/, '');
  if (!sanitizedReturnTo) return adminPath;
  if (!isSafeInternalPath(sanitizedReturnTo)) return adminPath;

  const blockedPaths = ['/', loginPath, authPath, ...pathsToIgnore].filter(
    Boolean,
  );
  // Compare pathnames: a blocked screen is just as blocked with a query
  // string (a used reset link's ?token= must not be resumed after login).
  const [returnPathname] = sanitizedReturnTo.split('?');
  if (blockedPaths.includes(returnPathname)) return adminPath;

  return sanitizedReturnTo;
};
